class MadesaBuyNow extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
  }

  connectedCallback() {
    this.button?.addEventListener('click', this.handleClick.bind(this));
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.handleClick.bind(this));
  }

  async handleClick(event) {
    event.preventDefault();

    try {
      // 1) Descobrir a variant selecionada na PDP
      const variantId = this.getSelectedVariantId();

      if (!variantId) {
        console.error('Não foi possível identificar a variant selecionada.');
        return;
      }

      // 2) Adiciona ao carrinho via Ajax API (não substitui o carrinho)
      const payload = { items: [{ id: Number(variantId), quantity: 1 }] };

      const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        console.error('Falha ao adicionar ao carrinho:', await res.text());
        return;
      }

      // 3) Redireciona para checkout com o carrinho atual (incluindo itens anteriores)
      window.location.href = '/cart';
    } catch (e) {
      console.error('Erro no Comprar agora:', e);
    }
  }

  getSelectedVariantId() {
    // Tenta pegar o ID da variant do form do produto
    const variantInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (variantInput) {
      return variantInput.value;
    }

    // Fallback: tenta pegar do produto mais próximo
    const productForm = this.closest('product-form-component, product-form');
    if (productForm) {
      const variantIdInput = productForm.querySelector('[name="id"]');
      return variantIdInput?.value;
    }

    return null;
  }
}

if (!customElements.get('madesa-buy-now')) {
  customElements.define('madesa-buy-now', MadesaBuyNow);
}
